"use client";
import { Box, Text } from "@chakra-ui/react";
import { CellContext, RowData } from "@tanstack/react-table";
import { useState } from "react";
import { BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";

export const BooleanCheckedSnippet = ({
  getValue,
}: CellContext<RowData, boolean>) => {
  const value = getValue();

  if (typeof value !== "boolean") {
    throw new Error("BooleanCheckedSnippet: value must be boolean");
  }

  return (
    <Box
      sx={{
        color: value ? "success.500" : "danger.500",
        fontSize: "1rem",
      }}
    >
      {value ? <BsCheckCircleFill /> : <BsXCircleFill />}
    </Box>
  );
};

export const TruncatedTextSnippet = ({
  getValue,
  column,
}: CellContext<unknown, unknown>) => {
  const [showFullText, setShowFullText] = useState(false);
  const value = getValue() as string;
  // fix-later;(Todo: Shirish)
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const meta: any = column.columnDef?.meta;

  if (typeof value !== "string") {
    throw new Error("truncatedTextSnippet: value must be string");
  }

  return (
    <>
      <Text
        as="span"
        {...meta?.cellProps}
        noOfLines={showFullText ? "none" : meta?.cellProps?.noOfLines || 1}
      >
        {value}
      </Text>
      <Text
        fontSize="xs"
        sx={{
          cursor: "pointer",
          color: "surface.700",
        }}
        _hover={{
          textDecoration: "underline",
          color: "primary.500",
        }}
        as="span"
        onClick={() => setShowFullText((prev) => !prev)}
        fontWeight={600}
      >
        {showFullText ? "Show less" : "Show more"}
      </Text>
    </>
  );
};
